module.exports = __webpack_public_path__ + "static/media/like-on.3af8c45e.png";